module.exports = __webpack_public_path__ + "media/images/products/cards/total_return_portfólio-82927a8c747ea0e0d726d77c8a5feccc.png";